'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiUserAdd = function TiUserAdd(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm15 23.3c2.3 0 4.4-0.9 5.9-2.4 1.5-1.5 2.4-3.6 2.4-5.9s-0.9-4.4-2.4-5.9c-1.5-1.5-3.6-2.4-5.9-2.4s-4.4 0.9-5.9 2.4c-1.5 1.5-2.4 3.6-2.4 5.9s0.9 4.4 2.4 5.9c1.5 1.5 3.6 2.4 5.9 2.4z m0 11.7c5.9 0 10-1.7 10-3.3 0-3.4-3.9-6.7-10-6.7-6.2 0-10 3.3-10 6.7 0 1.6 3.8 3.3 10 3.3z m20-15h-3.3v-3.3c0-1-0.8-1.7-1.7-1.7s-1.7 0.7-1.7 1.7v3.3h-3.3c-0.9 0-1.7 0.7-1.7 1.7s0.8 1.6 1.7 1.6h3.3v3.4c0 0.9 0.8 1.6 1.7 1.6s1.7-0.7 1.7-1.6v-3.4h3.3c0.9 0 1.7-0.7 1.7-1.6s-0.8-1.7-1.7-1.7z' })
        )
    );
};

exports.default = TiUserAdd;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/user-add.js
// module id = 2239
// module chunks = 0